export const FallbackFonts = ', Helvetica, Arial, sans-serif';